import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxModalComponent } from './phx-modal.component';
import { PhxModalConfirmComponent } from './phx-modal-confirm.component';
import { PhxModalBaseComponent } from './phx-modal-base.component';
import { PhxModalHeaderSelectDirective } from './phx-modal-header-select.directive';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxDialogModule } from '../dialog/phx-dialog.module';

@NgModule({
  declarations: [PhxModalBaseComponent, PhxModalComponent, PhxModalConfirmComponent, PhxModalHeaderSelectDirective],
  imports: [CommonModule, PhxIconButtonModule, PhxDialogModule],
  exports: [PhxModalConfirmComponent, PhxModalComponent, PhxModalHeaderSelectDirective],
})
export class PhxModalModule {}
